import { Action } from '../../../actions';
import {
    CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
    OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import {
    UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
    UPDATE_BANNER_VIDEO_CREATIVE_ID,
    UPDATE_BANNER_VIDEO_DATA
} from '../../../actions/video';
import { BannersEditMassActionsState, MassActionId } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsCPCVideoReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: Action,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        cpcVideoBulkReplacementEditorVisible: true
                    },
                    typeCreative: action.bannerType
                }
            };
        }
        case ON_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentActiveRadioButtonCPCVideo: action.value
                    }
                }
            };
        }
        case UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID:
        case UPDATE_BANNER_VIDEO_CREATIVE_ID:
            if (action.id !== MassActionId.bannersEdit) {
                return state;
            }

            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    inProgress: true
                }
            };
        case UPDATE_BANNER_VIDEO_DATA: {
            if (action.id !== MassActionId.bannersEdit) {
                return state;
            }

            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    inProgress: false
                }
            };
        }
        default:
            return state;
    }
}
